import { memo } from 'react';
import { Box, Text } from '@bonanza-social/moonlight';
import { PrizeWallInfoQuickRuleProps } from './PrizeWallInfoQuickRule.types';
import PrizeWallImage from '../../../common/PrizeWallImage/PrizeWallImage';

function PrizeWallInfoQuickRule({ title, image }: PrizeWallInfoQuickRuleProps) {
  return (
    <Box
      gap="space-200"
      alignItems="center"
      flexDirection="row"
      borderRadius="radius-400"
      paddingVertical="space-600"
      paddingHorizontal="space-400"
      borderWidth="border-width-025"
      borderColor="borderGoldSolid"
      backgroundColor="primaryBackgroundHover"
    >
      <PrizeWallImage {...image} width={79} height={56} />
      <Text variant="h5" color="darkSurfacePrimary" textAlign="center" flex={1}>
        {title}
      </Text>
    </Box>
  );
}

export default memo(PrizeWallInfoQuickRule);
